import React from 'react';
import styled from 'styled-components';
import { space, color } from 'styled-system';
import Text from 'theme/text';
import translations from 'translations';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 54px;
`;

const TabBtn = styled.button`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  border-radius: 12px;

  ${color}
  ${space}
`;

function Filters({ languageCode, selected = 'ALL', setSelected }) {
  return (
    <Wrapper>
      <TabBtn
        onClick={() => setSelected('ALL')}
        type="button"
        py="s"
        px="m"
        bg={selected === 'ALL' ? 'grey_400' : 'transparent'}
        mr="xs"
      >
        <Text
          fontSize="h3"
          lineHeight="h3"
          fontWeight={selected === 'DRAFT' ? 'bold' : 'medium'}
          color={selected === 'ALL' ? 'white' : 'grey_400'}
          textAlign="center"
        >
          {translations[languageCode].All}
        </Text>
        {/* <Text
        fontSize="pSmall"
        lineHeight="pSmall"
        fontWeight={selected === 'DRAFT' ? 'bold' : 'medium'}
        color={selected === 'ALL' ? 'white' : 'grey_400'}
        textAlign="center"
        ml="xs"
      >
        100
      </Text> */}
      </TabBtn>

      <TabBtn
        onClick={() => setSelected('DRAFT')}
        type="button"
        py="s"
        px="m"
        bg={selected === 'DRAFT' ? 'grey_150' : 'transparent'}
        mr="xs"
      >
        <Text
          fontSize="h3"
          lineHeight="h3"
          fontWeight={selected === 'DRAFT' ? 'bold' : 'medium'}
          color={selected === 'DRAFT' ? 'grey_600' : 'grey_400'}
          textAlign="center"
        >
          {translations[languageCode].Draft}
        </Text>
        {/*  <Text
        fontSize="pSmall"
        lineHeight="pSmall"
        fontWeight={selected === 'DRAFT' ? 'bold' : 'medium'}
        color={selected === 'DRAFT' ? 'grey_600' : 'grey_400'}
        textAlign="center"
        ml="xs"
      >
        100
      </Text> */}
      </TabBtn>

      <TabBtn
        onClick={() => setSelected('PASSIVE')}
        type="button"
        py="s"
        px="m"
        bg={selected === 'PASSIVE' ? 'primary_400' : 'transparent'}
        mr="xs"
      >
        <Text
          fontSize="h3"
          lineHeight="h3"
          fontWeight={selected === 'PASSIVE' ? 'bold' : 'medium'}
          color={selected === 'PASSIVE' ? 'white' : 'grey_400'}
          textAlign="center"
        >
          {translations[languageCode].Passive}
        </Text>
        {/* <Text
        fontSize="pSmall"
        lineHeight="pSmall"
        fontWeight={selected === 'PASSIVE' ? 'bold' : 'medium'}
        color={selected === 'PASSIVE' ? 'white' : 'grey_400'}
        textAlign="center"
        ml="xs"
      >
        100
      </Text> */}
      </TabBtn>

      <TabBtn
        onClick={() => setSelected('ACTIVE')}
        type="button"
        py="s"
        px="m"
        bg={selected === 'ACTIVE' ? 'orange_400' : 'transparent'}
        mr="xs"
      >
        <Text
          fontSize="h3"
          lineHeight="h3"
          fontWeight={selected === 'ACTIVE' ? 'bold' : 'medium'}
          color={selected === 'ACTIVE' ? 'white' : 'grey_400'}
          textAlign="center"
        >
          {translations[languageCode].Active}
        </Text>
        {/* <Text
        fontSize="pSmall"
        lineHeight="pSmall"
        fontWeight={selected === 'ACTIVE' ? 'bold' : 'medium'}
        color={selected === 'ACTIVE' ? 'white' : 'grey_400'}
        textAlign="center"
        ml="xs"
      >
        100
      </Text> */}
      </TabBtn>
    </Wrapper>
  );
}

export default Filters;
